import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyBookYourStay = loadable(() => import(/* webpackChunkName: "content/hotel/bookyourstay" */ './BookYourStay'));
